    <template>
    <div @click="$emit('click')" class="task-item">
        <div class="container-fluid card" :style="{ marginBottom: '.5rem', paddingLeft: '1.5rem', paddingRight: '1.5rem', borderRadius: '6px', borderLeftColor: colour }">
                <div class="row align-items-center" style="margin-top:.5rem; margin-bottom: 1rem;">
                    <div class="col-1">
                        <ui-checkbox v-model="completedProxy" style="margin-bottom: 0;" :disabled="true"></ui-checkbox>
                    </div>
                    <div class="col">
                        <span :style="completedProxy ? 'text-decoration: line-through; color: #ccc; vertical-align: middle;' : ''">{{ task.title }}</span>
                        <span v-if="task.description" class="line-clamp-1 subtle">{{ task.description }}</span>

                        <task-children :task="task" style="color: #999; font-size: 14px;"></task-children>

                        <span :class="'badge badge-secondary'" v-show="task.pending_complete_at && !task.completed_at" title="Pending Complete" style="background-color: orange; margin-left: .5rem;">
                            <span class="material-icons" style="font-size: inherit; vertical-align:top;">warning</span>
                        </span>
                        <span :style="completedProxy ? 'text-decoration: line-through; color: #ccc;' : ''" v-if="task.title && task.title.split(' ').length === 1 && task.description && task.description.length > 0">: {{ task.description }}</span>
                        <div style="margin-top: .2rem;">
                            <task-icons :task="task"></task-icons>
                        </div>
                    </div>
                    <div class="col-3 text-right">
                        <avatar v-if="task.assignee" :user="task.assignee" :show-label="false" inline></avatar>
                        <ui-icon-button v-if="showDestroy" @click.stop="$emit('destroy', task)" icon="delete" type="secondary" style="margin-left: 13px; vertical-align: middle;"></ui-icon-button>
                    </div>
                </div>
            </div>
    </div>
</template>

<style lang="scss">
    .task-item {
        cursor: pointer;

        .card { border-left: 8px solid #ccc; }

        &:hover .card {
            border: 1px solid #ddd;
            border-left: 8px solid #ccc;
        }

        .ui-checkbox { margin-top: 0 !important; }
    }
</style>

<script>
    import { TaskSchema } from '../../classes/Api/Task'
    import TaskIcons from './TaskMetaIcons'
    import TaskChildren from "./TaskChildren.vue";

    export default {
        components: {TaskChildren, TaskIcons },
        props: {
            task: {
                type: Object,
                default() {
                    return new TaskSchema();
                }
            },
            showDestroy: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            user() {
                return window.marque.ui.user;
            },
            completedProxy: {
                get() {
                    return this.task.completed_at || this.task.pending_complete_at ? true : false;
                },
                set(value) {
                    // Do nothing.
                }
            },
            colour() {
                if (this.task.template && this.task.template.colour) {
                    return this.task.template.colour
                } else if (this.task.template && this.task.template.template && this.task.template.template.colour) {
                    return this.task.template.template.colour
                }

                return '#ccc'
            }
        }
    }
</script>